import React, { useState, useEffect, useCallback } from 'react'; // useCallback əlavə edildi
import AppSpinner from "../Spinner/AppSpinner";
import { Modal, Form } from 'react-bootstrap';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";

const EditTrainingModal = ({ show, onHide, trainingId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({ id: 0, name: '', description: '' });

  // 1. Funksiyanı useCallback ilə bükürük ki, hər renderdə yenidən yaranmasın
  const fetchTrainingDetails = useCallback(async () => {
    if (!trainingId) return;

    setLoading(true);
    try {
      const response = await apiFetch(`${BASE_URL}/trainings/${trainingId}`);
      const data = await response.json();
      if (data && data.training) {
        setFormData({
          id: data.training.id,
          name: data.training.name || '',
          description: data.training.description || ''
        });
      }
    } catch (err) {
      console.error("Məlumat gətirilərkən xəta:", err);
    } finally {
      setLoading(false);
    }
  }, [trainingId]); // trainingId dəyişəndə funksiya yenilənəcək

  // 2. İndi fetchTrainingDetails-i dependency array-ə təhlükəsiz şəkildə əlavə edə bilərik
  useEffect(() => {
    if (show && trainingId) {
      fetchTrainingDetails();
    }
  }, [show, trainingId, fetchTrainingDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await apiFetch(`${BASE_URL}/trainings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) { 
        onSuccess(); 
        onHide(); 
      } else {
        alert("Yadda saxlanarkən xəta baş verdi.");
      }
    } catch (err) {
      console.error("Server xətası:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton style={{
        background: '#f3f4f6',
        borderBottom: '1px solid #e5e7eb',
        padding: '10px 16px'
      }}>
        <Modal.Title style={{ fontWeight: 700, color: '#374151', fontSize: 15 }}>
          Təlimi Redaktə Et
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body style={{ padding: '20px', background: '#fff' }}>
          <AppSpinner show={loading} text="Məlumatlar gətirilir..." />
          {!loading && (
            <div className="row g-3">
              <div className="col-md-12">
                <Form.Group>
                  <Form.Label style={{ fontWeight: 600, color: '#374151', fontSize: 12, textTransform: 'uppercase', marginBottom: 4 }}>
                    Təlim Adı
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{ borderRadius: 6, padding: '8px 12px', fontSize: 13, border: '1px solid #d1d5db' }}
                  />
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group>
                  <Form.Label style={{ fontWeight: 600, color: '#374151', fontSize: 12, textTransform: 'uppercase', marginBottom: 4 }}>
                    Təsvir
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Təlim haqqında təsvir yazın..."
                    style={{ borderRadius: 6, padding: '8px 12px', fontSize: 13, border: '1px solid #d1d5db' }}
                  />
                </Form.Group>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{ background: '#f3f4f6', borderTop: '1px solid #e5e7eb', padding: '10px 16px' }}>
          <button
            type="button"
            onClick={onHide}
            style={{
              fontWeight: 600, borderRadius: 6, fontSize: 12,
              padding: '6px 16px', background: '#6b7280',
              color: '#fff', border: 'none', cursor: 'pointer'
            }}
          >
            Ləğv et
          </button>
          <button
            type="submit"
            disabled={saving || loading}
            style={{
              fontWeight: 600, borderRadius: 6, fontSize: 12,
              padding: '6px 20px', background: saving || loading ? '#bfdbfe' : '#3b82f6',
              color: '#fff', border: 'none',
              cursor: saving || loading ? 'not-allowed' : 'pointer'
            }}
          >
            {saving ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <AppSpinner inline /> Saxlanılır...
              </span>
            ) : 'Yadda saxla'}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditTrainingModal;